/* eslint-disable-next-line import/no-unresolved */
import { createContext, createElement, memo, useState } from 'react';

const initialValue = null;
const initialState = [initialValue, () => {}];

export const SelectedStrategyContext = createContext(initialState);

export const SelectedStrategyProvider = memo(({ children }) => {
  const [data, setData] = useState(initialValue);
  return createElement(
    SelectedStrategyContext.Provider,
    { value: [data, setData] },
    ...(Array.isArray(children) ? children : [children]),
  );
});

// SelectedStrategyProvider.propTypes = {
//   children: PropTypes.node.isRequired,
// };
